import React from 'react';

export const DefaultMark = ({ width = 8, height = 8, className, style }) => {
  return <svg
    width={width}
    height={height}
    className={className}
    style={style}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_980_25702)">
      <path
        d="M3.99995 5.91666L1.94261 6.99833L2.33561 4.70733L0.668945 3.08499L2.96895 2.75166L3.99761 0.667328L5.02628 2.75166L7.32628 3.08499L5.65961 4.70733L6.05261 6.99833L3.99995 5.91666Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_980_25702">
        <rect width="8" height="8" fill="white"/>
      </clipPath>
    </defs>
  </svg>;
}